const countries = [
  ['Afghanistan (‫افغانستان‬‎)', 'af', '93', 'Asia/Kabul'],
  ['Albania (Shqipëri)', 'al', '355', 'Europe/Tirane'],
  ['Algeria (‫الجزائر‬‎)', 'dz', '213', 'Africa/Algiers'],
  ['American Samoa', 'as', '1684', 'Pacific/Pago_Pago'],
  ['Andorra', 'ad', '376', 'Europe/Andorra'],
  ['Angola', 'ao', '244', 'Africa/Luanda'],
  ['Anguilla', 'ai', '1264', 'America/Anguilla'],
  ['Antigua and Barbuda', 'ag', '1268', 'America/Antigua'],
  ['Argentina', 'ar', '54', 'America/Argentina/Buenos_Aires'],
  ['Armenia (Հայաստան)', 'am', '374', 'Asia/Yerevan'],
  ['Aruba', 'aw', '297', 'America/Aruba'],
  ['Australia', 'au', '61', 'Australia/Canberra', 0],
  ['Austria (Österreich)', 'at', '43', 'Europe/Vienna'],
  ['Azerbaijan (Azərbaycan)', 'az', '994', 'Asia/Baku'],
  ['Bahamas', 'bs', '1242', 'America/Nassau'],
  ['Bahrain (‫البحرين‬‎)', 'bh', '973', 'Asia/Bahrain'],
  ['Bangladesh (বাংলাদেশ)', 'bd', '880', 'Asia/Dhaka'],
  ['Barbados', 'bb', '1246', 'America/Barbados'],
  ['Belarus (Беларусь)', 'by', '375', 'Europe/Minsk'],
  ['Belgium (België)', 'be', '32', 'Europe/Brussels'],
  ['Belize', 'bz', '501', 'America/Belize'],
  ['Benin (Bénin)', 'bj', '229', 'Africa/Porto-Novo'],
  ['Bermuda', 'bm', '1441', 'Atlantic/Bermuda'],
  ['Bhutan (འབྲུག)', 'bt', '975', 'Asia/Thimphu'],
  ['Bolivia', 'bo', '591', 'America/La_Paz'],
  ['Bosnia and Herzegovina (Босна и Херцеговина)', 'ba', '387', 'Europe/Sarajevo'],
  ['Botswana', 'bw', '267', 'Africa/Gaborone'],
  ['Brazil (Brasil)', 'br', '55', 'America/Brasilia'],
  ['British Indian Ocean Territory', 'io', '246', 'Indian/Chagos'],
  ['British Virgin Islands', 'vg', '1284', 'America/Tortola'],
  ['Brunei', 'bn', '673', 'Asia/Brunei'],
  ['Bulgaria (България)', 'bg', '359', 'Europe/Sofia'],
  ['Burkina Faso', 'bf', '226', 'Africa/Ouagadougou'],
  ['Burundi (Uburundi)', 'bi', '257', 'Africa/Bujumbura'],
  ['Cambodia (កម្ពុជា)', 'kh', '855', 'Asia/Phnom_Penh'],
  ['Cameroon (Cameroun)', 'cm', '237', 'Africa/Yaounde'],
  [
    'Canada',
    'ca',
    '1',
    'America/Toronto',
    1,
    [
      '204',
      '226',
      '236',
      '249',
      '250',
      '289',
      '306',
      '343',
      '365',
      '387',
      '403',
      '416',
      '418',
      '431',
      '437',
      '438',
      '450',
      '506',
      '514',
      '519',
      '548',
      '579',
      '581',
      '587',
      '604',
      '613',
      '639',
      '647',
      '672',
      '705',
      '709',
      '742',
      '778',
      '780',
      '782',
      '807',
      '819',
      '825',
      '867',
      '873',
      '902',
      '905',
    ],
  ],
  ['Cape Verde (Kabu Verdi)', 'cv', '238', 'Atlantic/Cape_Verde'],
  ['Caribbean Netherlands', 'bq', '599', 'America/Kralendijk', 1],
  ['Cayman Islands', 'ky', '1345', 'America/Cayman'],
  ['Central African Republic (République centrafricaine)', 'cf', '236', 'Africa/Bangui'],
  ['Chad (Tchad)', 'td', '235', 'Africa/Ndjamena'],
  ['Chile', 'cl', '56', 'America/Santiago'],
  ['China (中国)', 'cn', '86', 'Asia/Shanghai'],
  ['Christmas Island', 'cx', '61', 'Indian/Christmas', 2],
  ['Cocos (Keeling) Islands', 'cc', '61', 'Indian/Cocos', 1],
  ['Colombia', 'co', '57', 'America/Bogota'],
  ['Comoros (‫جزر القمر‬‎)', 'km', '269', 'Indian/Comoro'],
  ['Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)', 'cd', '243', 'Africa/Kinshasa'],
  ['Congo (Republic) (Congo-Brazzaville)', 'cg', '242', 'Africa/Brazzaville'],
  ['Cook Islands', 'ck', '682', 'Pacific/Rarotonga'],
  ['Costa Rica', 'cr', '506', 'America/Costa_Rica'],
  ['Côte d’Ivoire', 'ci', '225', 'Africa/Abidjan'],
  ['Croatia (Hrvatska)', 'hr', '385', 'Europe/Zagreb'],
  ['Cuba', 'cu', '53', 'America/Havana'],
  ['Curaçao', 'cw', '599', 'America/Curacao', 0],
  ['Cyprus (Κύπρος)', 'cy', '357', 'Asia/Nicosia'],
  ['Czech Republic (Česká republika)', 'cz', '420', 'Europe/Prague'],
  ['Denmark (Danmark)', 'dk', '45', 'Europe/Copenhagen'],
  ['Djibouti', 'dj', '253', 'Africa/Djibouti'],
  ['Dominica', 'dm', '1767', 'America/Dominica'],
  [
    'Dominican Republic (República Dominicana)',
    'do',
    '1',
    'America/Santo_Domingo',
    2,
    ['809', '829', '849'],
  ],
  ['Ecuador', 'ec', '593', 'America/Guayaquil'],
  ['Egypt (‫مصر‬‎)', 'eg', '20', 'Africa/Cairo'],
  ['El Salvador', 'sv', '503', 'America/El_Salvador'],
  ['Equatorial Guinea (Guinea Ecuatorial)', 'gq', '240', 'Africa/Malabo'],
  ['Eritrea', 'er', '291', 'Africa/Asmara'],
  ['Estonia (Eesti)', 'ee', '372', 'Europe/Tallinn'],
  ['Ethiopia', 'et', '251', 'Africa/Addis_Ababa'],
  ['Falkland Islands (Islas Malvinas)', 'fk', '500', 'Atlantic/Stanley'],
  ['Faroe Islands (Føroyar)', 'fo', '298', 'Atlantic/Faroe'],
  ['Fiji', 'fj', '679', 'Pacific/Fiji'],
  ['Finland (Suomi)', 'fi', '358', 'Europe/Helsinki', 0],
  ['France', 'fr', '33', 'Europe/Paris'],
  ['French Guiana (Guyane française)', 'gf', '594', 'America/Cayenne'],
  ['French Polynesia (Polynésie française)', 'pf', '689', 'Pacific/Tahiti'],
  ['Gabon', 'ga', '241', 'Africa/Libreville'],
  ['Gambia', 'gm', '220', 'Africa/Banjul'],
  ['Georgia (საქართველო)', 'ge', '995', 'Asia/Tbilisi'],
  ['Germany (Deutschland)', 'de', '49', 'Europe/Berlin'],
  ['Ghana (Gaana)', 'gh', '233', 'Africa/Accra'],
  ['Gibraltar', 'gi', '350', 'Europe/Gibraltar'],
  ['Greece (Ελλάδα)', 'gr', '30', 'Europe/Athens'],
  ['Greenland (Kalaallit Nunaat)', 'gl', '299', 'America/Nuuk'],
  ['Grenada', 'gd', '1473', 'America/Grenada'],
  ['Guadeloupe', 'gp', '590', 'America/Guadeloupe', 0],
  ['Guam', 'gu', '1671', 'Pacific/Guam'],
  ['Guatemala', 'gt', '502', 'America/Guatemala'],
  ['Guernsey', 'gg', '44', 'Europe/Guernsey', 1],
  ['Guinea (Guinée)', 'gn', '224', 'Africa/Conakry'],
  ['Guinea-Bissau (Guiné Bissau)', 'gw', '245', 'Africa/Bissau'],
  ['Guyana', 'gy', '592', 'America/Guyana'],
  ['Haiti', 'ht', '509', 'America/Port-au-Prince'],
  ['Honduras', 'hn', '504', 'America/Tegucigalpa'],
  ['Hong Kong (香港)', 'hk', '852', 'Asia/Hong_Kong'],
  ['Hungary (Magyarország)', 'hu', '36', 'Europe/Budapest'],
  ['Iceland (Ísland)', 'is', '354', 'Atlantic/Reykjavik'],
  ['India (भारत)', 'in', '91', 'Asia/Kolkata'],
  ['Indonesia', 'id', '62', 'Asia/Jakarta'],
  ['Iran (‫ایران‬‎)', 'ir', '98', 'Asia/Tehran'],
  ['Iraq (‫العراق‬‎)', 'iq', '964', 'Asia/Baghdad'],
  ['Ireland', 'ie', '353', 'Europe/Dublin'],
  ['Isle of Man', 'im', '44', 'Europe/Isle_of_Man', 2],
  ['Israel (‫ישראל‬‎)', 'il', '972', 'Asia/Jerusalem'],
  ['Italy (Italia)', 'it', '39', 'Europe/Rome', 0],
  ['Jamaica', 'jm', '1876', 'America/Jamaica'],
  ['Japan (日本)', 'jp', '81', 'Asia/Tokyo'],
  ['Jersey', 'je', '44', 'Europe/Jersey', 3],
  ['Jordan (‫الأردن‬‎)', 'jo', '962', 'Asia/Amman'],
  ['Kazakhstan (Казахстан)', 'kz', '7', 'Asia/Almaty', 1],
  ['Kenya', 'ke', '254', 'Africa/Nairobi'],
  ['Kiribati', 'ki', '686', 'Pacific/Tarawa'],
  ['Kosovo', 'xk', '383', 'Europe/Belgrade'],
  ['Kuwait (‫الكويت‬‎)', 'kw', '965', 'Asia/Kuwait'],
  ['Kyrgyzstan (Кыргызстан)', 'kg', '996', 'Asia/Bishkek'],
  ['Laos (ລາວ)', 'la', '856', 'Asia/Vientiane'],
  ['Latvia (Latvija)', 'lv', '371', 'Europe/Riga'],
  ['Lebanon (‫لبنان‬‎)', 'lb', '961', 'Asia/Beirut'],
  ['Lesotho', 'ls', '266', 'Africa/Maseru'],
  ['Liberia', 'lr', '231', 'Africa/Monrovia'],
  ['Libya (‫ليبيا‬‎)', 'ly', '218', 'Africa/Tripoli'],
  ['Liechtenstein', 'li', '423', 'Europe/Vaduz'],
  ['Lithuania (Lietuva)', 'lt', '370', 'Europe/Vilnius'],
  ['Luxembourg', 'lu', '352', 'Europe/Luxembourg'],
  ['Macau (澳門)', 'mo', '853', 'Asia/Macau'],
  ['Madagascar (Madagasikara)', 'mg', '261', 'Indian/Antananarivo'],
  ['Malawi', 'mw', '265', 'Africa/Blantyre'],
  ['Malaysia', 'my', '60', 'Asia/Kuala_Lumpur'],
  ['Maldives', 'mv', '960', 'Indian/Maldives'],
  ['Mali', 'ml', '223', 'Africa/Bamako'],
  ['Malta', 'mt', '356', 'Europe/Malta'],
  ['Marshall Islands', 'mh', '692', 'Pacific/Majuro'],
  ['Martinique', 'mq', '596', 'America/Martinique'],
  ['Mauritania (‫موريتانيا‬‎)', 'mr', '222', 'Africa/Nouakchott'],
  ['Mauritius (Moris)', 'mu', '230', 'Indian/Mauritius'],
  ['Mayotte', 'yt', '262', 'Indian/Mayotte'],
  ['Mexico (México)', 'mx', '52', 'America/Mexico_City'],
  ['Micronesia', 'fm', '691', 'Pacific/Pohnpei'],
  ['Moldova (Republica Moldova)', 'md', '373', 'Europe/Chisinau'],
  ['Monaco', 'mc', '377', 'Europe/Monaco'],
  ['Mongolia (Монгол)', 'mn', '976', 'Asia/Ulaanbaatar'],
  ['Montenegro (Crna Gora)', 'me', '382', 'Europe/Podgorica'],
  ['Montserrat', 'ms', '1664', 'America/Montserrat'],
  ['Morocco (‫المغرب‬‎)', 'ma', '212', 'Africa/Casablanca', 0],
  ['Mozambique (Moçambique)', 'mz', '258', 'Africa/Maputo'],
  ['Myanmar (Burma)', 'mm', '95', 'Asia/Yangon'],
  ['Namibia (Namibië)', 'na', '264', 'Africa/Windhoek'],
  ['Nauru', 'nr', '674', 'Pacific/Nauru'],
  ['Nepal (नेपाल)', 'np', '977', 'Asia/Kathmandu'],
  ['Netherlands (Nederland)', 'nl', '31', 'Europe/Amsterdam'],
  ['New Caledonia (Nouvelle-Calédonie)', 'nc', '687', 'Pacific/Noumea'],
  ['New Zealand', 'nz', '64', 'Pacific/Auckland'],
  ['Nicaragua', 'ni', '505', 'America/Managua'],
  ['Niger (Nijar)', 'ne', '227', 'Africa/Niamey'],
  ['Nigeria', 'ng', '234', 'Africa/Lagos'],
  ['Niue', 'nu', '683', 'Pacific/Niue'],
  ['Norfolk Island', 'nf', '672', 'Pacific/Norfolk'],
  ['North Korea (조선 민주주의 인민 공화국)', 'kp', '850', 'Asia/Pyongyang'],
  ['North Macedonia (Северна Македонија)', 'mk', '389', 'Europe/Skopje'],
  ['Northern Mariana Islands', 'mp', '1670', 'Pacific/Saipan'],
  ['Norway (Norge)', 'no', '47', 'Europe/Oslo', 0],
  ['Oman (‫عُمان‬‎)', 'om', '968', 'Asia/Muscat'],
  ['Pakistan (‫پاکستان‬‎)', 'pk', '92', 'Asia/Karachi'],
  ['Palau', 'pw', '680', 'Pacific/Palau'],
  ['Palestine (‫فلسطين‬‎)', 'ps', '970', 'Asia/Gaza'],
  ['Panama (Panamá)', 'pa', '507', 'America/Panama'],
  ['Papua New Guinea', 'pg', '675', 'Pacific/Port_Moresby'],
  ['Paraguay', 'py', '595', 'America/Asuncion'],
  ['Peru (Perú)', 'pe', '51', 'America/Lima'],
  ['Philippines', 'ph', '63', 'Asia/Manila'],
  ['Poland (Polska)', 'pl', '48', 'Europe/Warsaw'],
  ['Portugal', 'pt', '351', 'Europe/Lisbon'],
  ['Puerto Rico', 'pr', '1', 'America/Puerto_Rico', 3, ['787', '939']],
  ['Qatar (‫قطر‬‎)', 'qa', '974', 'Asia/Qatar'],
  ['Réunion (La Réunion)', 're', '262', 'Indian/Reunion', 0],
  ['Romania (România)', 'ro', '40', 'Europe/Bucharest'],
  ['Russia (Россия)', 'ru', '7', 'Europe/Moscow', 0],
  ['Rwanda', 'rw', '250', 'Africa/Kigali'],
  ['Saint Barthélemy', 'bl', '590', 'America/St_Barthelemy', 1],
  ['Saint Helena', 'sh', '290', 'Atlantic/St_Helena'],
  ['Saint Kitts and Nevis', 'kn', '1869', 'America/St_Kitts'],
  ['Saint Lucia', 'lc', '1758', 'America/St_Lucia'],
  ['Saint Martin (Saint-Martin)', 'mf', '590', 'America/Marigot', 2],
  ['Saint Pierre and Miquelon', 'pm', '508', 'America/Miquelon'],
  ['Saint Vincent and the Grenadines', 'vc', '1784', 'America/St_Vincent'],
  ['Samoa', 'ws', '685', 'Pacific/Apia'],
  ['San Marino', 'sm', '378', 'Europe/San_Marino'],
  ['São Tomé and Príncipe (São Tomé e Príncipe)', 'st', '239', 'Africa/Sao_Tome'],
  ['Saudi Arabia (‫المملكة العربية السعودية‬‎)', 'sa', '966', 'Asia/Riyadh'],
  ['Senegal (Sénégal)', 'sn', '221', 'Africa/Dakar'],
  ['Serbia (Србија)', 'rs', '381', 'Europe/Belgrade'],
  ['Seychelles', 'sc', '248', 'Indian/Mahe'],
  ['Sierra Leone', 'sl', '232', 'Africa/Freetown'],
  ['Singapore', 'sg', '65', 'Asia/Singapore'],
  ['Sint Maarten', 'sx', '1721', 'America/Lower_Princes'],
  ['Slovakia (Slovensko)', 'sk', '421', 'Europe/Bratislava'],
  ['Slovenia (Slovenija)', 'si', '386', 'Europe/Ljubljana'],
  ['Solomon Islands', 'sb', '677', 'Pacific/Guadalcanal'],
  ['Somalia (Soomaaliya)', 'so', '252', 'Africa/Mogadishu'],
  ['South Africa', 'za', '27', 'Africa/Johannesburg'],
  ['South Korea (대한민국)', 'kr', '82', 'Asia/Seoul'],
  ['South Sudan (‫جنوب السودان‬‎)', 'ss', '211', 'Africa/Juba'],
  ['Spain (España)', 'es', '34', 'Europe/Madrid'],
  ['Sri Lanka (ශ්‍රී ලංකාව)', 'lk', '94', 'Asia/Colombo'],
  ['Sudan (‫السودان‬‎)', 'sd', '249', 'Africa/Khartoum'],
  ['Suriname', 'sr', '597', 'America/Paramaribo'],
  ['Svalbard and Jan Mayen', 'sj', '47', 'Arctic/Longyearbyen', 1],
  ['Swaziland (Eswatini)', 'sz', '268', 'Africa/Mbabane'],
  ['Sweden (Sverige)', 'se', '46', 'Europe/Stockholm'],
  ['Switzerland (Schweiz)', 'ch', '41', 'Europe/Zurich'],
  ['Syria (‫سوريا‬‎)', 'sy', '963', 'Asia/Damascus'],
  ['Taiwan (台灣)', 'tw', '886', 'Asia/Taipei'],
  ['Tajikistan', 'tj', '992', 'Asia/Dushanbe'],
  ['Tanzania', 'tz', '255', 'Africa/Dar_es_Salaam'],
  ['Thailand (ไทย)', 'th', '66', 'Asia/Bangkok'],
  ['Timor-Leste', 'tl', '670', 'Asia/Dili'],
  ['Togo', 'tg', '228', 'Africa/Lome'],
  ['Tokelau', 'tk', '690', 'Pacific/Fakaofo'],
  ['Tonga', 'to', '676', 'Pacific/Tongatapu'],
  ['Trinidad and Tobago', 'tt', '1868', 'America/Port_of_Spain'],
  ['Tunisia (‫تونس‬‎)', 'tn', '216', 'Africa/Tunis'],
  ['Turkey (Türkiye)', 'tr', '90', 'Europe/Istanbul'],
  ['Turkmenistan', 'tm', '993', 'Asia/Ashgabat'],
  ['Turks and Caicos Islands', 'tc', '1649', 'America/Grand_Turk'],
  ['Tuvalu', 'tv', '688', 'Pacific/Funafuti'],
  ['U.S. Virgin Islands', 'vi', '1340', 'America/St_Thomas'],
  ['Uganda', 'ug', '256', 'Africa/Kampala'],
  ['Ukraine (Україна)', 'ua', '380', 'Europe/Kyiv'],
  ['United Arab Emirates (‫الإمارات العربية المتحدة‬‎)', 'ae', '971', 'Asia/Dubai'],
  ['United Kingdom', 'gb', '44', 'Europe/London', 0],
  ['United States', 'us', '1', 'America/New_York', 0],
  ['Uruguay', 'uy', '598', 'America/Montevideo'],
  ['Uzbekistan (Oʻzbekiston)', 'uz', '998', 'Asia/Tashkent'],
  ['Vanuatu', 'vu', '678', 'Pacific/Efate'],
  ['Vatican City (Città del Vaticano)', 'va', '39', 'Europe/Vatican', 1],
  ['Venezuela', 've', '58', 'America/Caracas'],
  ['Vietnam (Việt Nam)', 'vn', '84', 'Asia/Ho_Chi_Minh'],
  ['Wallis and Futuna', 'wf', '681', 'Pacific/Wallis'],
  ['Western Sahara (‫الصحراء الغربية‬‎)', 'eh', '212', 'Africa/El_Aaiun', 1],
  ['Yemen (‫اليمن‬‎)', 'ye', '967', 'Asia/Aden'],
  ['Zambia', 'zm', '260', 'Africa/Lusaka'],
  ['Zimbabwe', 'zw', '263', 'Africa/Harare'],
  ['Åland Islands', 'ax', '358', 'Europe/Mariehamn', 1],
]

// Method to convert countries array to the specified format
export const convertCountriesToObjectFormat = () => {
  return countries
    .map((country) => {
      // Handle countries with additional data (like Canada with area codes)
      const countryData = Array.isArray(country) ? country : [country]

      // Ensure we have all required fields
      if (!countryData[0] || !countryData[1] || !countryData[3]) {
        console.warn('Malformed country data:', countryData)
        return null
      }

      return {
        title: countryData[0], // Country name
        id: countryData[1], // Country code
        zone: countryData[3], // Timezone
      }
    })
    .filter((country) => country !== null) // Remove any null entries
}

// Method to get countries in the new format (can be called on created)
export const getCountriesList = () => {
  return convertCountriesToObjectFormat()
}

export default countries
